export const PickupOrderedNotificationTypeName = 'PickupOrdered';
export const PickupOnDateOrderedNotificationTypeName = 'PickupOnDateOrdered';
export const EmptyDetectionNotificationTypeName = 'EmptyDetection';
export const OfflineForXHoursNotificationTypeName = 'OfflineForXHours';
export const FillLevelNotificationTypeName = 'FillLevel';
export const CustomMessagesNotificationTypeName = 'CustomMessages';
export const BalesAlmostFinishedNotificationTypeName = 'BaleAlmostFinished';
export const BalesFinishedNotificationTypeName = 'BaleFinished';
export const BalesReadyForPickupNotificationTypeName = 'BalesReadyForPickup';
